import coreClient from "../coreClient";
import { DailyRewards } from "../models/response/RewardsPayload";

export function getDailyRewards(userId: string){
    return coreClient.get(`/Rewards/Daily?UserId=${userId}`)
}